// extracted by mini-css-extract-plugin
export default {"buttons":"PrimaryAndSecondaryButtonContainer_buttons__REFGU"};